export const messages = {
  en: {
    //   staff: {
    //     searchConditions: 'Search Conditions',
    //     staffIdPlaceholder: 'Enter Staff ID',
    //     staffNamePlaceholder: 'Enter Staff Name',
    //     phonePlaceholder: 'Enter Phone Number',
    //     search: 'Search',
    //     staffInfo: 'Staff Information',
    //     add: 'Add',
    //     staffId: 'Staff ID',
    //     name: 'Name',
    //     phone: 'Phone',
    //     relatedOrg: 'Related Organization',
    //     position: 'Position',
    //     idCard: 'ID Card',
    //     address: 'Address',
    //     gender: 'Gender',
    //     male: 'Male',
    //     female: 'Female',
    //     operations: 'Operations',
    //     edit: 'Edit',
    //     resetPwd: 'Reset Password',
    //     delete: 'Delete',
    //     details: 'Details',
    //     tip: 'Tip: The default password for new employees is 123456. After assigning roles and permissions to the community and associating roles with employees, they can log in.',
    //     confirmOperation: 'Please confirm your operation',
    //     confirmReset: 'Are you sure to reset the password?',
    //     confirmResetPassword: 'Are you sure to reset the password?',
    //     cancel: 'Cancel',
    //     confirmResetBtn: 'Confirm Reset',
    //     editStaff: 'Edit Staff',
    //     requiredName: 'Required, enter staff name',
    //     requiredPosition: 'Required, select position',
    //     optionalIdCard: 'Optional, enter ID card',
    //     requiredPhone: 'Required, enter phone number',
    //     requiredGender: 'Required, select gender',
    //     requiredAddress: 'Required, enter address',
    //     uploadPhoto: 'Upload Photo',
    //     confirmDelete: 'Are you sure to delete? Before deleting an employee, please confirm that the employee has completed the relevant approval process. After deletion, the relevant process cannot continue. Please operate with caution!',
    //     confirmDeleteBtn: 'Confirm Delete'
    //   }
    // },
    // zh: {
    //   staff: {
    //     searchConditions: '查询条件',
    //     staffIdPlaceholder: '请输入员工ID',
    //     staffNamePlaceholder: '请输入员工名称',
    //     phonePlaceholder: '请输入手机号',
    //     search: '查询',
    //     staffInfo: '员工信息',
    //     add: '添加',
    //     staffId: '员工编号',
    //     name: '名称',
    //     phone: '手机号',
    //     relatedOrg: '关联组织',
    //     position: '岗位',
    //     idCard: '身份证',
    //     address: '地址',
    //     gender: '性别',
    //     male: '男',
    //     female: '女',
    //     operations: '操作',
    //     edit: '修改',
    //     resetPwd: '重置密码',
    //     delete: '删除',
    //     details: '详情',
    //     tip: '温馨提示：新添加员工默认密码为123456，角色权限分配园区并且角色关联员工后可登录',
    //     confirmOperation: '请确认您的操作',
    //     confirmReset: '确认是否重置密码',
    //     confirmResetPassword: '确认是否重置密码',
    //     cancel: '点错了',
    //     confirmResetBtn: '确认重置',
    //     editStaff: '修改员工',
    //     requiredName: '必填，请填写员工名称',
    //     requiredPosition: '必填，请选择岗位',
    //     optionalIdCard: '可选，请填写身份证',
    //     requiredPhone: '必填，请填写手机号码',
    //     requiredGender: '必填，请选择员工性别',
    //     requiredAddress: '必填，请填写家庭住址',
    //     uploadPhoto: '上传照片',
    //     confirmDelete: '确认是否删除，删除员工前请确认员工已完成相关审批流程，删除后相关流程将无法继续进行，请慎重操作！',
    //     confirmDeleteBtn: '确认删除'
    //   }
  }
}